import { CreditCardIcon } from "assets/icons/CreditCardIcon";
import { Button } from "primereact/button";
import styled from "styled-components";

import { StyledRadioButton } from "../styled";
import { PaymentAmount } from "./PaymentAmount";

interface ICardAccordionProps {
  children: React.ReactNode;
  showStylings: boolean;
  title: string;
  isFirstCard: boolean;
  showFooter: boolean;
  checked?: boolean;
  onRadioButtonChange?: any;
  radioValue?: number;
  cardAmount: number;
  totalPaymentAmount: number;
  onAmountChange?: (value: number) => void;
  handleRemoveSecondCard?: any;
  isProcessing?: boolean;
  showAmountInput?: boolean;
  footerText?: string;
}
interface IStyledContainerProps {
  showStylings: boolean;
}

interface IStyledContentContainerProps {
  showStylings: boolean;
}

const StyledContainer = styled.div<IStyledContainerProps>`
  border: ${({ showStylings }) =>
    showStylings ? "1px solid #D2D6DB" : "none"};
  border-radius: 8px;
  box-shadow: ${({ showStylings }) =>
    showStylings ? "0px 1px 2px 0px rgba(16, 24, 40, 0.05)" : ""};
  margin-bottom: ${({ showStylings }) => (showStylings ? "24px" : "0")};
`;

const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledContentContainer = styled.div<IStyledContentContainerProps>`
  padding: ${({ showStylings }) => (showStylings ? "16px" : "0")};
`;

const StyledFooter = styled.div`
  padding: 10px 16px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #d2d6db;
`;

const StyledTitleContainer = styled.div`
  border-bottom: 1px solid #d2d6db;
  i {
    color: #64636e;
    font-size: 14px;
  }
`;

export function CardAccordion({
  children,
  showStylings,
  title,
  isFirstCard,
  showFooter = false,
  checked,
  onRadioButtonChange,
  radioValue,
  cardAmount,
  totalPaymentAmount,
  onAmountChange,
  handleRemoveSecondCard,
  isProcessing,
  showAmountInput = true,
  footerText,
}: ICardAccordionProps) {
  return (
    <StyledContainer showStylings={showStylings}>
      {showStylings && (
        <StyledHeader>
          <StyledTitleContainer className="flex align-items-center justify-content-between p-3">
            <div className="flex gap-2 align-items-center">
              <CreditCardIcon
                className="h-auto"
                style={{
                  width: "40px",
                  minWidth: "40px",
                }}
              />
              {title}
            </div>
            {!isFirstCard && (
              <Button
                className="p-button-text p-button-danger p-0"
                onClick={handleRemoveSecondCard}
                disabled={isProcessing}
                icon="pi pi-trash"
              />
            )}
          </StyledTitleContainer>
          {showStylings && showAmountInput && (
            <PaymentAmount
              id={`${radioValue === 0 ? "first" : "second"}-card-amount`}
              value={cardAmount}
              max={totalPaymentAmount - 1}
              onValueChange={onAmountChange}
              className="p-3 pb-0"
              title={
                isFirstCard ? "Card Balance" : "Second Card Payment Amount"
              }
              editable={!isFirstCard}
            />
          )}
        </StyledHeader>
      )}
      <StyledContentContainer showStylings={showStylings}>
        {children}
      </StyledContentContainer>
      {showFooter && (
        <StyledFooter>
          <p
            className={`text-sm text-center font-normal mb-0 ${
              checked ? "purple" : "gray"
            }`}
          >
            {footerText || "Use this card for future auto payments"}
          </p>
          <StyledRadioButton
            inputId={`${radioValue === 0 ? "first" : "second"} card-future`}
            name="future-payment"
            value={radioValue}
            checked={checked}
            onChange={onRadioButtonChange}
            width={15}
            height={15}
          />
        </StyledFooter>
      )}
    </StyledContainer>
  );
}
